import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import { withStyles } from '@material-ui/core/styles';
import Transition from './Transition';
import FormComponent from '../FormComponent';
import EnhancedTable from '../table/EnhancedTable';
import { post } from '../../modules/utility';

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 50px 20px 50px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		// maxWidth : '100%',
		// width: 800,
		//maxWidth: '98%',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
});

class UnknownPricingRepliesDialog extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			unknownPricingReplies: undefined,
			isSearching: false,
		};
	}

	componentDidUpdate(prevProps) {
		const { open, showErrors } = this.props;
		const { unknownPricingReplies } = this.state;

		if (open && prevProps.open !== open && !unknownPricingReplies) {
			post({
				method: 'unknownPricingReply.search',
				params: {
					afterDate: moment().subtract(60, 'days').format('YYYY-MM-DD'),
				},
				callback: (err, r) => {
					this.setState({ isSearching: false });
					if (err) {
						this.setState({ isSavingOpen: false });
						return showErrors(_.isArray(err) ? err : [err]);
					}
					this.setState({
						savingStatus: 'done',
						unknownPricingReplies: r.collections.unknownPricingReplyCollection,
					});
				},
			});
		}
	}

	handleClose = () => {
		this.setState(
			{
				isSaving: false,
			},
			this.props.onClose
		);
	};

	render() {
		const { classes, open, fullScreen } = this.props;
		const { unknownPricingReplies } = this.state;
		if (!unknownPricingReplies) {
			return null;
		}

		// table
		const cols = [
			{ sortId: 'fromMobileNumber', displayId: 'fromMobileNumber', label: 'From Number' },
			{ sortId: 'dateCreated', displayId: 'dateCreatedDisplay', label: 'Date/time Received' },
			{ sortId: 'message', displayId: 'message', label: 'Message' },
			{ sortId: 'statusMessage', displayId: 'statusMessage', label: 'Parse Results' },
		];
		const rows = unknownPricingReplies.map((reply) => {
			const {
				unknownPricingReplyId,
				fromMobileNumber,
				message,
				statusMessage,
				dateCreated,
			} = reply;
			return {
				key: unknownPricingReplyId,
				dateCreated,
				dateCreatedDisplay: moment(dateCreated).format('dddd, M/D h:mm a'),
				fromMobileNumber,
				message,
				statusMessage,
			};
		});
		return (
			<Dialog
				maxWidth="lg"
				fullScreen={fullScreen}
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{ paper: classes.dialogPaper }}
				fullWidth={true}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>Unknown Pricing SMS Messages</DialogTitle>
					<DialogContent>
						<div className={classes.newPrices}>
							<EnhancedTable
								columns={cols}
								rows={rows}
								isDense={true}
								defaultOrderBy={'dateCreated'}
								defaultOrder={'desc'}
							/>
						</div>
					</DialogContent>
				</div>
			</Dialog>
		);
	}
}

UnknownPricingRepliesDialog.propTypes = {
	fullScreen: PropTypes.bool.isRequired,
	classes: PropTypes.object.isRequired,
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
};

export default _.flow([withStyles(styles), withMobileDialog()])(UnknownPricingRepliesDialog);
